/**
 * REFERRAL POPUP - Referral discount popup functionality
 * 
 * This file contains:
 * - URL parameter detection for referral codes (aic parameter)
 * - Popup display logic for referral discount notifications
 * - Close button functionality
 */

// Constants
const POPUP_CLASSES = {
  REFERRAL_DISCOUNT: 'referral-discount-popup'
};

const ANIMATION_TIMEOUTS = {
  POPUP_SHOW: 10,
  POPUP_HIDE: 300
};

// Helper Functions
/**
 * Get URL parameter value
 * @param {string} paramName - The parameter name to look for
 * @returns {string|null} Parameter value or null if not found
 */
function getUrlParameter(paramName) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(paramName);
}

/**
 * Check if a string is valid (not empty, not just whitespace)
 * @param {string|null} str - The string to validate
 * @returns {boolean} True if string is valid
 */
function isValidString(str) {
  return str !== null && str !== undefined && str.trim() !== '';
}

/**
 * Configure referral popup element
 * @returns {HTMLElement|null} Configured popup element or null if not found
 */
function configureReferralPopupElement() {
  const popup = document.getElementById('referral-discount-popup');
  
  if (!popup) {
    return null;
  }

  // console.log(`✅ [REFERRAL-POPUP] Found popup element: referral-discount-popup`);

  // Configure close button
  const closeButton = popup.querySelector('.popup-button--close');
  if (closeButton) {
    /** @type {any} */ (closeButton).onclick = () => hideReferralPopup(popup);
  }

  return popup;
}

/**
 * Hide popup with animation
 * @param {HTMLElement} popup - Popup element to hide
 */
function hideReferralPopup(popup) {
  popup.classList.remove('show');
  setTimeout(() => {
    popup.classList.remove('popup-visible');
    popup.classList.add('popup-hidden');
  }, ANIMATION_TIMEOUTS.POPUP_HIDE);
}

/**
 * Show popup with animation
 * @param {HTMLElement} popup - Popup element to show
 */
function showReferralPopup(popup) {
  popup.classList.remove('popup-hidden');
  popup.classList.add('popup-visible');
  setTimeout(() => {
    popup.classList.add('show');
  }, ANIMATION_TIMEOUTS.POPUP_SHOW);
}

/**
 * Check for referral code in URL and show popup if found
 */
function checkAndShowReferralPopup() {
  try {
    // Check for 'aic' parameter in URL
    const aicValue = getUrlParameter('aic');
    
    // console.log(`🔍 [REFERRAL-POPUP] Checking for 'aic' parameter:`, aicValue);
    
    // If aic parameter exists and has a valid value
    if (isValidString(aicValue)) {
      // console.log(`✅ [REFERRAL-POPUP] Valid referral code found: ${aicValue}`);
      
      // Configure and show the popup
      const popup = configureReferralPopupElement();
      if (popup) {
        showReferralPopup(popup);
        // console.log(`🎉 [REFERRAL-POPUP] Referral popup displayed for code: ${aicValue}`);
      }
    } else {
      // console.log(`ℹ️ [REFERRAL-POPUP] No valid referral code found in URL`);
    }
  } catch (error) {
  }
}

/**
 * Initialize referral popup functionality
 */
function initReferralPopup() {
  // Wait for DOM to be fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndShowReferralPopup);
  } else {
    // DOM is already loaded
    checkAndShowReferralPopup();
  }
}

// Export functions for global access
if (typeof window !== "undefined") {
  /** @type {any} */ (window).ReferralPopup = {
    checkAndShowReferralPopup,
    showReferralPopup,
    hideReferralPopup,
    getUrlParameter,
    isValidString
  };
}

// Initialize when script loads
initReferralPopup();
